import React, { useState, useEffect } from 'react';
import LayersSelection from 'components/customComponents/Layers/LayersSelection';
import { useRMSelector } from 'redux/hooks';
import {
  selectIsEditable,
  selectIsModifyAccessRights,
} from 'redux/selectors/StateSelectors';
import { isNullOrUndefined, LayerType } from 'utils/Global';
import NoLayer from 'components/customComponents/Layers/NoLayer';
import RMAccordian from 'components/customComponents/Controls/RMAccordian';
import { GridLayerDTO, LayerTypeDTO } from 'business/models/Models';
import {
  selectExperimentLayers,
  selectIsLayerSelected,
} from 'redux/selectors/ExperimentStateSelector';
import { DrawingLayer } from 'business/models/DrawingLayer';
import {
  useAllowLayerEditing,
  useIsLayerRemovalAllowed,
  useLayerDeleteHandler,
} from 'redux/hooks/experiment';
export enum GridLayerTypes {
  SUBGRID = 1000,
}
function LayersSelectionParent({
  layers,
  selectedParentLayerId = 0,
  customStyle = null,
  handleSelection = null,
  isSubGrid = false,
}) {
  const [startIndex, setStartIndex] = useState<number>(0);
  const isEditMode: boolean = useRMSelector(selectIsEditable);
  const modifyAccessRights: boolean = useRMSelector(selectIsModifyAccessRights);
  const [_layers, setLayers] = useState<DrawingLayer[]>([]);
  const layerRemovalAllowed = useIsLayerRemovalAllowed();
  const _reduxLayers = useRMSelector(selectExperimentLayers);
  const selectedLayer = _layers.find((l) => l.id === selectedParentLayerId);
  const isLayerSelected = useRMSelector(selectIsLayerSelected);
  const handleDeleteLayer = useLayerDeleteHandler();
  const isLayerEditingAllowed = useAllowLayerEditing();

  useEffect(() => {
    if (layers) {
      if (isSubGrid) {
        setLayers([...layers]);
      } else {
        setLayers(
          [...layers].filter(
            (layer: any) =>
              layer.type !== LayerType.Grid || layer.layerDetail?.subGridNumber == 1,
          ),
        );
      }
    }
  }, [layers]);

  const LAYERSELECTIONCOUNT = 5;
  function nextIndex() {
    if (startIndex + LAYERSELECTIONCOUNT < _layers.length) {
      setStartIndex(startIndex + 1);
    }
  }

  function previousIndex() {
    if (startIndex > 0) {
      setStartIndex(startIndex - 1);
    }
  }

  function isActiveLayer(layer) {
    if (!layer || selectedParentLayerId === 0 || !selectedLayer) {
      return false;
    }
    if (selectedParentLayerId !== 0) {
      if (selectedParentLayerId === layer.id) {
        return true;
      } else if (
        !isSubGrid &&
        layer.type == LayerTypeDTO.Grid &&
        selectedLayer?.type == LayerTypeDTO.Grid
      ) {
        return (
          (selectedLayer.layerDetail as GridLayerDTO).gridId == layer.layerDetail.gridId
        );
      }
      return false;
    }
  }

  function getLayerType(layer) {
    if (
      !isSubGrid &&
      layer.type == LayerTypeDTO.Grid &&
      _reduxLayers.findIndex(
        (lyr) =>
          lyr.id != layer.id &&
          lyr.type == LayerTypeDTO.Grid &&
          (lyr.layerDetail as GridLayerDTO).gridId == layer.layerDetail.gridId,
      ) > -1
    ) {
      return GridLayerTypes.SUBGRID;
    }
    return layer.type;
  }

  function getLayersView() {
    const layersView = [];
    let iter = startIndex;
    const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });

    if (isNullOrUndefined(_layers)) {
      return layersView;
    }

    if (_layers.length < 1) {
      layersView.push(<NoLayer  />);
    } else {
      _layers
        .sort((a, b) => collator.compare(a.name, b.name))
        .map((layer, i) => {
          if (i >= startIndex && iter < startIndex + LAYERSELECTIONCOUNT) {
            const layerType = getLayerType(layer);
            layersView.push(
              <LayersSelection
                type={layerType}
                active={isActiveLayer(layer)}
                text={`${layerType === GridLayerTypes.SUBGRID ? 'Group ' : ''}${
                  layer.name
                }`}
                onClick={() => handleSelection(layer.id)}
                enableDelete={
                  isEditMode &&
                  layerRemovalAllowed &&
                  modifyAccessRights &&
                  isLayerEditingAllowed
                }
                onDeleteLayer={() => {
                  handleDeleteLayer(layer.id, isSubGrid);
                }}
                activeClass={getActiveClass()}
                locked={layer?.locked}
              />,
            );
            iter++;
          }
        });
    }
    return layersView;
  }

  const getActiveClass = () => {
    if (isSubGrid) {
      return 'active-layers-selection-sub';
    } else if (isLayerSelected) {
      return 'active-layers-selection';
    } else {
      return 'active-layers-selection-dim';
    }
  };

  return (
    <>
      <RMAccordian nextClick={nextIndex} preClick={previousIndex} style={customStyle}>
        {getLayersView()}
      </RMAccordian>
    </>
  );
}

export default LayersSelectionParent;
